<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <basics
            v-if='(estimate && estimate.estimate_type !== "SE")||(estimate && project)'
            :estimate='estimate'
            :project='project ? project : null'
            :wos='wos'
            @update='updateEstimate'
            @updateDetail='updateEstimateDetail'
          ></basics>
        </v-col>
        <v-col cols='12' md='4'>
          <site-address
            v-if="estimate && estimate.estimate_type !== 'SE'"
            :estimate='estimate'
            @update='updateEstimate'
          ></site-address>
          <wc-data-box
            v-if="estimate && estimate.estimate_type === 'SE'"
            :title='$store.state.icons.dataBox.address.title'
            :titleIcon='$store.state.icons.dataBox.address.icon'
            :titleIconColor='$store.state.icons.dataBox.address.iconColor'
            showHelp
            helpText='This site address is pulled from the project directly and is not editable here.'
          >
            <v-card-text v-if='!project && loading'>
              <wc-loading line msg='getting site address...'></wc-loading>
            </v-card-text>
            <v-card-text v-if='!project && !loading'>No project address found</v-card-text>
            
            <wc-two-column-table v-if='project' :items='projectAddress'></wc-two-column-table>
          </wc-data-box>
        </v-col>

        <v-col cols='12' md='4'>
          <irrigation-details
            v-if="estimate && estimateDetail && estimate.estimate_type == 'NI'"
            :estimate='estimate'
            :estimateDetail='estimateDetail'
            @update='updateEstimate'
            @updateDetail='updateEstimateDetail'
          ></irrigation-details>
          <takeover-details
            :isLoading='isLoading'
            v-if="estimate && estimateDetail && estimate.estimate_type == 'ST'"
            :estimate='estimate'
            :estimateDetail='estimateDetail'
            @update='updateEstimate'
            @updateDetail='updateEstimateDetail'
          ></takeover-details>
          <wc-data-box
            v-if="estimate && (estimate.estimate_type !== 'NI' && estimate.estimate_type !== 'ST')"
            title='no details'
            :titleIcon='$store.state.icons.dataBox.details.icon'
            :titleIconColor='$store.state.icons.dataBox.details.iconColor'
          ></wc-data-box>
        </v-col>

        <v-col cols='12' md='4'>
          <contacts
            v-if="estimate && estimate.estimate_type !== 'SE'"
            :estimate='estimate'
            @update='updateEstimate'
          ></contacts>
          <project-contacts
            v-if="estimate && estimate.estimate_type == 'SE' && project"
            :project='project'
          ></project-contacts>
        </v-col>

        <v-col cols='12' md='4'>
          <estimate-subd-tier
            v-if="estimate && (estimate.estimate_type !== 'SE' && estimate.estimate_type !== 'SN')"
            :estimateDetail='estimateDetail'
            @updateDetail='updateEstimateDetail'
            :disableEdit='estimate.is_sold'
          ></estimate-subd-tier>
          <wc-data-box
            v-else
            title='no subd tier'
            :titleIcon='$store.state.icons.dataBox.subdTier.icon'
            :titleIconColor='$store.state.icons.dataBox.subdTier.iconColor'
          ></wc-data-box>
        </v-col>
        <v-col cols='12' md='4'></v-col>
        </v-row>


        <wc-page-section class='mt-n7' title='Files'></wc-page-section>

        <v-row>
          <v-col cols='12' md='12'>
            <estimate-files
              v-if="estimate"
              :files='estimate.estimate_file_data'
              :estimate_id='estimate.id'
              :disabled='estimate.is_sold'
            ></estimate-files>
          </v-col>
      </v-row>

      <wc-page-section class='mt-n7' title='Notes and Considerations'></wc-page-section>
      <v-row v-if="estimate.estimate_type === 'NI'">
        <v-col cols='12' md='6'>
          <first-call-notes
            v-if="estimate && estimateDetail"
            :estimate='estimate'
            :estimateDetail='estimateDetail'
            @updateDetail='updateEstimateDetail'
          ></first-call-notes>
        </v-col>
        <v-col cols='12' md='6'>
          <prod-schd-notes
            v-if="estimate && estimateDetail"
            :estimate='estimate'
            :estimateDetail='estimateDetail'
            @updateDetail='updateEstimateDetail'
          ></prod-schd-notes>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' md='4' v-if="estimate.estimate_type == 'NI'">
          <mechanical-notes
            v-if="estimate && estimateDetail"
            :estimate='estimate'
            :estimateDetail='estimateDetail'
            @updateDetail='updateEstimateDetail'
          ></mechanical-notes>
          <mech-schd-notes
            class='mt-6'
            v-if="estimate && estimateDetail"
            :estimate='estimate'
            :estimateDetail='estimateDetail'
            @updateDetail='updateEstimateDetail'
          ></mech-schd-notes>
        </v-col>
        <v-col cols='12' md='4' v-if="estimate.estimate_type !== 'NI'">
          <single-value-box
            v-if="estimateDetail"
            v-model='estimateDetail.service_schedule_considerations'
            title='Scheduling Considerations'
            titleIcon='mdi-calendar-cursor'
            titleIconColor='primary'
            hint='is there anything to know for scheduling this work order?'
            :showEdit='!estimate.is_sold'
            @update='updateEstimateDetail(estimateDetail)'
          ></single-value-box>
        </v-col>
        <v-col cols='12' md='4'>
          <invoicing-notes
            v-if='estimate'
            :estimate='estimate'
            @update='updateEstimate'
          ></invoicing-notes>
        </v-col>
        <v-col cols='12' md='4'>
          <stickies
            ref='stickies'
            v-if='estimate'
            :estimate='estimate'
          ></stickies>
        </v-col>

      </v-row>
      <wc-page-section class='mt-n7' title='Costs and Pricing'></wc-page-section>
      <v-row>
        <v-col cols='12' md='8' v-if="estimate.estimate_type !== 'NI'">
          <estimate-options
            v-if='estimate'
            :estimate='estimate'
          ></estimate-options>
        </v-col>
        <v-col cols='12' md='4' v-if="estimate.estimate_type == 'NI'">
          <head-count
            v-if='estimate && estimateDetail'
            :estimate='estimate'
            :estimateDetail='estimateDetail'
            @update='updateEstimate'
            @updateDetail='updateEstimateDetail'
          ></head-count>
        </v-col>
        <v-col cols='12' md='4' v-if="estimate.estimate_type == 'NI'">
          <!-- eventually, the plan is to replace these next components with the new options component (workflow link with todos/tasks) MJ -->
          <misc-options
            v-if="estimate && estimateDetail"
            :estimate='estimate'
            :estimateDetail='estimateDetail'
            @updateDetail='updateEstimateDetail'
          ></misc-options>
          <options
            class='mt-6'
            v-if="estimate && estimateDetail"
            :estimate='estimate'
            :estimateDetail='estimateDetail'
            @updateDetail='updateEstimateDetail'
            @update='updateEstimate'
          ></options>

        </v-col>
        <v-col cols='12' md='4'>
          <estimate-amount
            v-if="estimate"
            :estimate='estimate'
            @update='updateEstimate'
          ></estimate-amount>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from '@/modules/estimates/components/Basics';
import SiteAddress from '@/modules/estimates/components/SiteAddress';
import IrrigationDetails from '@/modules/estimates/components/irrigation/Details';
import TakeoverDetails from '@/modules/estimates/components/irrigation/TakeoverDetails';
import Contacts from '@/modules/estimates/components/Contacts';
import ProjectContacts from '@/modules/irrigation/components/Contacts';
import InvoicingNotes from '@/modules/estimates/components/InvoicingNotes';
import EstimateSUBDTier from '@/modules/estimates/components/irrigation/EstimateSUBDTier';
import MechanicalNotes from '@/modules/estimates/components/irrigation/MechanicalNotes';
import FirstCallNotes from '@/modules/estimates/components/irrigation/FirstCallNotes';
import MechanicalScheduleNotes from '@/modules/estimates/components/irrigation/MechanicalScheduleNotes';
import ProductionScheduleNotes from '@/modules/estimates/components/irrigation/ProductionScheduleNotes';
import HeadCount from '@/modules/estimates/components/irrigation/HeadCount';
import EstimateFiles from '@/components/files/EstimateFiles';
import EstimateOptions from '@/modules/estimates/components/irrigation/EstimateOptions';
import Options from '@/modules/estimates/components/irrigation/Options';
import MiscOptions from '@/modules/estimates/components/irrigation/MiscOptions';
import Stickies from '@/modules/projects/components/Stickies';
import EstimateAmount from '@/modules/estimates/components/EstimateAmount';
import SingleValueBox from '@/modules/estimates/components/irrigation/SingleValueBox';

import wosAPI from '@/modules/wos/api';
import estimatesAPI from '@/modules/estimates/api/estimates';
import _ from 'lodash';

export default {
  name: 'irrigation-estimate-overview',
  props: {
    estimate: {
      required: true
    },
    project: {
      required: false
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: true,
    isSavingOption: false,
    estimateDetail: null,
    options: [],
    wos: []
  }),
  computed: {
    subtitle () {
      if (this.estimate.site_address) {
        return this.estimate.site_address;
      } else {
        return "";
      }
    },
    projectAddress () {
      if (this.project) {
        return [
          { text: 'Address', value: this.project.site_address },
          { text: 'City', value: this.project.site_city },
          { text: 'Province', value: this.project.site_province },
          { text: 'Postal Code', value: this.project.site_postal_code }
        ]
      }
      return []
    }
  },
  created () {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.estimateDetail = _.cloneDeep(this.estimate.estimate_detail);
      this.wos = await wosAPI.getEstimateWOs(this.estimate.id);
      this.isLoading = false;
    },
    async updateEstimate (estimate) {
      this.$emit('update', estimate);
    },
    async updateEstimateDetail (estimateDetail) {
      this.isLoading = true;
      this.estimateDetail = await estimatesAPI.updateIrrigationEstimate(estimateDetail);
      this.estimate.estimate_detail = this.estimateDetail;
      this.isLoading = false;
    }
  },
  components: {
    'basics': Basics,
    'site-address': SiteAddress,
    'irrigation-details': IrrigationDetails,
    'takeover-details': TakeoverDetails,
    'contacts': Contacts,
    'project-contacts': ProjectContacts,
    'invoicing-notes': InvoicingNotes,
    'estimate-subd-tier': EstimateSUBDTier,
    'mechanical-notes': MechanicalNotes,
    'first-call-notes': FirstCallNotes,
    'mech-schd-notes': MechanicalScheduleNotes,
    'prod-schd-notes': ProductionScheduleNotes,
    'head-count': HeadCount,
    'estimate-options': EstimateOptions,
    'options': Options,
    'misc-options': MiscOptions,
    'estimate-files': EstimateFiles,
    'stickies': Stickies,
    'estimate-amount': EstimateAmount,
    'single-value-box': SingleValueBox,
  }
}
</script>